// extracted by mini-css-extract-plugin
module.exports = {"rating":"Ne26Eo","hasHalfStar":"_3fP0wE","one":"_39BfCv","two":"_2Z0VKo","three":"_1OBVBp","four":"_2fG_UI"};